/**
 * Project List Data
 */
const projectList = [
    {
        title: "Chat App Update",
        updatedTime: '2 year Ago',
        badgeText: 'Inprogress',
        badgeClass: 'warning',
        member : [
            {
              img: 'assets/images/users/avatar-1.jpg'
            },
            {
              img: 'assets/images/users/avatar-3.jpg'
            },
            {
              text: 'J',
              variant: 'bg-light text-primary'
            },
          ],
        cardBorderColor: 'warning',
    },
    {
      title: "ABC Project Customization",
      updatedTime:"2 month Ago",
      badgeText :"Progress",
      badgeClass:"primary",
      member : [
        {
          img:'assets/images/users/avatar-8.jpg'
        },
        {
          img:'assets/images/users/avatar-7.jpg'
        },
        {
          img:'assets/images/users/avatar-6.jpg'
        },
        {
          text: '2+',
          variant: 'bg-primary'
        },
      ],
      cardBorderColor:"success",
    },
    {
      title: "Client - Frank Hook",
      updatedTime:"1 hr Ago",
      badgeText :"New",
      badgeClass:"info",
      member : [
        {
          img:'assets/images/users/avatar-4.jpg'
        },
        {
          text: 'M',
          variant: 'bg-light text-primary'
        },
        {
          img:'assets/images/users/avatar-3.jpg'
        }
      ],
      cardBorderColor:"info",
    },
    {
      title: "Velzon Project",
      updatedTime:"11 hr Ago",
      badgeText :"Completed",
      badgeClass:"warning",
      member : [
        {
          img:'assets/images/users/avatar-7.jpg'
        },
        {
          img:'assets/images/users/avatar-5.jpg'
        }
      ],
      cardBorderColor:"info",
    },
    {
      title: "Brand Logo Design",
      updatedTime:"10 min Ago",
      badgeText :"New",
      badgeClass:"info",
      member : [
        {
          img:'assets/images/users/avatar-7.jpg'
        },
        {
          img:'assets/images/users/avatar-6.jpg'
        },
        {
          text: 'E',
          variant: 'bg-light text-primary'
        }
      ],
      cardBorderColor:"danger",
    },
    {
      title: "Brand Logo Design",
      updatedTime:"10 min Ago",
      badgeText :"New",
      badgeClass:"info",
      member : [
        {
          img:'assets/images/users/avatar-7.jpg'
        },
        {
          img:'assets/images/users/avatar-6.jpg'
        },
        {
          text: 'R',
          variant: 'bg-light text-primary'
        }
      ],
      cardBorderColor:"danger",
    },
    {
      title: "Project Update",
      updatedTime:"48 min Ago",
      badgeText :"Inprogress",
      badgeClass:"warning",
      member : [
        {
          img:'assets/images/users/avatar-4.jpg'
        },
        {
          img:'assets/images/users/avatar-5.jpg'
        },
        {
          img:'assets/images/users/avatar-6.jpg'
        },
      ],
      cardBorderColor:"warning",
    },
    {
      title: "Client - Jennifer",
      updatedTime:"30 min Ago",
      badgeText :"Process",
      badgeClass:"primary",
      member : [
        {
          img:'assets/images/users/avatar-1.jpg'
        },
      ],
      cardBorderColor:"success",
    },
    {
      title: "Business Template -UI/UX design",
      updatedTime:"7 month Ago",
      badgeText :"Completed",
      badgeClass:"success",
      member : [
        {
          img:'assets/images/users/avatar-1.jpg'
        },
        {
          img:'assets/images/users/avatar-3.jpg'
        },
        {
          text: '2+',
          variant: 'bg-primary'
        },
      ],
      cardBorderColor:"info",
    },
    {
      title: "Update Project",
      updatedTime:"1 month Ago",
      badgeText :"New",
      badgeClass:"info",
      member : [
        {
          img:'assets/images/users/avatar-7.jpg'
        },
      ],
      cardBorderColor:"success",
    },
    {
      title: "Bank Management System",
      updatedTime:"10 month Ago",
      badgeText :"Completed",
      badgeClass:"success",
      member : [
        {
          img:'assets/images/users/avatar-7.jpg'
        },
        {
          img:'assets/images/users/avatar-6.jpg'
        },
        {
          text: '2+',
          variant: 'bg-primary'
        },
      ],
      cardBorderColor:"danger",
    },
    {
      title: "PSD to HTML Convert",
      updatedTime:"29 min Ago",
      badgeText :"New",
      badgeClass:"info",
      member : [
        {
          img:'assets/images/users/avatar-7.jpg'
        }
      ],
      cardBorderColor:"primary",
    },
  ];
  
  /**
   * Document Data
   */
  const document=[
    {
        id:1,
        icon:"ri-file-zip-fill",
        iconBackgroundClass:"primary",
        fileName:"Artboard-documents.zip",
        fileType:"Zip File",
        fileSize:"4.57 MB",
        updatedDate:"12 Dec 2021"
    },
    {
        id:2,
        icon:"ri-file-pdf-fill",
        iconBackgroundClass:"danger",
        fileName:"Bank Management System",
        fileType:"PDF File",
        fileSize:"8.89 MB",
        updatedDate:"24 Nov 2021"
    },
    {
        id:3,
        icon:"ri-video-line",
        iconBackgroundClass:"secondary",
        fileName:"Tour-video.mp4",
        fileType:"MP4 File",
        fileSize:"14.62 MB",
        updatedDate:"19 Nov 2021"
    },
    {
        id:4,
        icon:"ri-file-excel-fill",
        iconBackgroundClass:"secondary",
        fileName:"Tour-video.mp4",
        fileType:"XSL File",
        fileSize:"2.38 KB",
        updatedDate:"14 Nov 2021"
    },
    {
        id:5,
        icon:"ri-folder-line",
        iconBackgroundClass:"info",
        fileName:"Project Screenshots Collection",
        fileType:"Folder File",
        fileSize:"87.24 MB",
        updatedDate:"08 Nov 2021"
    },
    {
        id:6,
        icon:"ri-image-2-fill",
        iconBackgroundClass:"danger",
        fileName:"Velzon-logo.png",
        fileType:"PNG File",
        fileSize:"879 KB",
        updatedDate:"02 Nov 2021"
    },
  ]
  
  
  export { projectList, document };
  